export const allCountryCodes = [
  {
    code: "AF",
    dialCode: "+93",
    flag: "https://flagsapi.com/AF/flat/32.png",
    length: 9,
  },
  {
    code: "AL",
    dialCode: "+355",
    flag: "https://flagsapi.com/AL/flat/32.png",
    length: 9,
  },
  {
    code: "DZ",
    dialCode: "+213",
    flag: "https://flagsapi.com/DZ/flat/32.png",
    length: 9,
  },
  {
    code: "AS",
    dialCode: "+1-684",
    flag: "https://flagsapi.com/AS/flat/32.png",
    length: 7,
  },
  {
    code: "AD",
    dialCode: "+376",
    flag: "https://flagsapi.com/AD/flat/32.png",
    length: 6,
  },
  {
    code: "AO",
    dialCode: "+244",
    flag: "https://flagsapi.com/AO/flat/32.png",
    length: 9,
  },
  {
    code: "AI",
    dialCode: "+1-264",
    flag: "https://flagsapi.com/AI/flat/32.png",
    length: 7,
  },
  {
    code: "AG",
    dialCode: "+1-268",
    flag: "https://flagsapi.com/AG/flat/32.png",
    length: 7,
  },
  {
    code: "AR",
    dialCode: "+54",
    flag: "https://flagsapi.com/AR/flat/32.png",
    length: 10,
  },
  {
    code: "AM",
    dialCode: "+374",
    flag: "https://flagsapi.com/AM/flat/32.png",
    length: 8,
  },
  {
    code: "AW",
    dialCode: "+297",
    flag: "https://flagsapi.com/AW/flat/32.png",
    length: 7,
  },
  {
    code: "AU",
    dialCode: "+61",
    flag: "https://flagsapi.com/AU/flat/32.png",
    length: 9,
  },
  {
    code: "AT",
    dialCode: "+43",
    flag: "https://flagsapi.com/AT/flat/32.png",
    length: 10,
  },
  {
    code: "AZ",
    dialCode: "+994",
    flag: "https://flagsapi.com/AZ/flat/32.png",
    length: 9,
  },
  {
    code: "BS",
    dialCode: "+1-242",
    flag: "https://flagsapi.com/BS/flat/32.png",
    length: 7,
  },
  {
    code: "BH",
    dialCode: "+973",
    flag: "https://flagsapi.com/BH/flat/32.png",
    length: 8,
  },
  {
    code: "BD",
    dialCode: "+880",
    flag: "https://flagsapi.com/BD/flat/32.png",
    length: 11,
  },
  {
    code: "BB",
    dialCode: "+1-246",
    flag: "https://flagsapi.com/BB/flat/32.png",
    length: 7,
  },
  {
    code: "BY",
    dialCode: "+375",
    flag: "https://flagsapi.com/BY/flat/32.png",
    length: 9,
  },
  {
    code: "BE",
    dialCode: "+32",
    flag: "https://flagsapi.com/BE/flat/32.png",
    length: 9,
  },
  {
    code: "BZ",
    dialCode: "+501",
    flag: "https://flagsapi.com/BZ/flat/32.png",
    length: 7,
  },
  {
    code: "BJ",
    dialCode: "+229",
    flag: "https://flagsapi.com/BJ/flat/32.png",
    length: 8,
  },
  {
    code: "BM",
    dialCode: "+1-441",
    flag: "https://flagsapi.com/BM/flat/32.png",
    length: 7,
  },
  {
    code: "BT",
    dialCode: "+975",
    flag: "https://flagsapi.com/BT/flat/32.png",
    length: 8,
  },
  {
    code: "BO",
    dialCode: "+591",
    flag: "https://flagsapi.com/BO/flat/32.png",
    length: 8,
  },
  {
    code: "BA",
    dialCode: "+387",
    flag: "https://flagsapi.com/BA/flat/32.png",
    length: 8,
  },
  {
    code: "BW",
    dialCode: "+267",
    flag: "https://flagsapi.com/BW/flat/32.png",
    length: 7,
  },
  {
    code: "BR",
    dialCode: "+55",
    flag: "https://flagsapi.com/BR/flat/32.png",
    length: 11,
  },
  {
    code: "BN",
    dialCode: "+673",
    flag: "https://flagsapi.com/BN/flat/32.png",
    length: 7,
  },
  {
    code: "BG",
    dialCode: "+359",
    flag: "https://flagsapi.com/BG/flat/32.png",
    length: 9,
  },
  {
    code: "BF",
    dialCode: "+226",
    flag: "https://flagsapi.com/BF/flat/32.png",
    length: 8,
  },
  {
    code: "BI",
    dialCode: "+257",
    flag: "https://flagsapi.com/BI/flat/32.png",
    length: 8,
  },
  {
    code: "KH",
    dialCode: "+855",
    flag: "https://flagsapi.com/KH/flat/32.png",
    length: 8,
  },
  {
    code: "CM",
    dialCode: "+237",
    flag: "https://flagsapi.com/CM/flat/32.png",
    length: 9,
  },
  {
    code: "CA",
    dialCode: "+1",
    flag: "https://flagsapi.com/CA/flat/32.png",
    length: 10,
  },
  {
    code: "CV",
    dialCode: "+238",
    flag: "https://flagsapi.com/CV/flat/32.png",
    length: 7,
  },
  {
    code: "KY",
    dialCode: "+1-345",
    flag: "https://flagsapi.com/KY/flat/32.png",
    length: 7,
  },
  {
    code: "CF",
    dialCode: "+236",
    flag: "https://flagsapi.com/CF/flat/32.png",
    length: 8,
  },
  {
    code: "TD",
    dialCode: "+235",
    flag: "https://flagsapi.com/TD/flat/32.png",
    length: 8,
  },
  {
    code: "CL",
    dialCode: "+56",
    flag: "https://flagsapi.com/CL/flat/32.png",
    length: 9,
  },
  {
    code: "CN",
    dialCode: "+86",
    flag: "https://flagsapi.com/CN/flat/32.png",
    length: 11,
  },
  {
    code: "DE",
    dialCode: "+49",
    flag: "https://flagsapi.com/DE/flat/32.png",
    length: 11,
  },
  {
    code: "EG",
    dialCode: "+20",
    flag: "https://flagsapi.com/EG/flat/32.png",
    length: 10,
  },
  {
    code: "ES",
    dialCode: "+34",
    flag: "https://flagsapi.com/ES/flat/32.png",
    length: 9,
  },
  {
    code: "FI",
    dialCode: "+358",
    flag: "https://flagsapi.com/FI/flat/32.png",
    length: 9,
  },
  {
    code: "FR",
    dialCode: "+33",
    flag: "https://flagsapi.com/FR/flat/32.png",
    length: 9,
  },
  {
    code: "GB",
    dialCode: "+44",
    flag: "https://flagsapi.com/GB/flat/32.png",
    length: 10,
  },
  {
    code: "GR",
    dialCode: "+30",
    flag: "https://flagsapi.com/GR/flat/32.png",
    length: 10,
  },
  {
    code: "IN",
    dialCode: "+91",
    flag: "https://flagsapi.com/IN/flat/32.png",
    length: 10,
  },
  {
    code: "IT",
    dialCode: "+39",
    flag: "https://flagsapi.com/IT/flat/32.png",
    length: 10,
  },
  {
    code: "JP",
    dialCode: "+81",
    flag: "https://flagsapi.com/JP/flat/32.png",
    length: 10,
  },
  {
    code: "KE",
    dialCode: "+254",
    flag: "https://flagsapi.com/KE/flat/32.png",
    length: 10,
  },
  {
    code: "KR",
    dialCode: "+82",
    flag: "https://flagsapi.com/KR/flat/32.png",
    length: 10,
  },
  {
    code: "MX",
    dialCode: "+52",
    flag: "https://flagsapi.com/MX/flat/32.png",
    length: 10,
  },
  {
    code: "NG",
    dialCode: "+234",
    flag: "https://flagsapi.com/NG/flat/32.png",
    length: 10,
  },
  {
    code: "NL",
    dialCode: "+31",
    flag: "https://flagsapi.com/NL/flat/32.png",
    length: 9,
  },
  {
    code: "NZ",
    dialCode: "+64",
    flag: "https://flagsapi.com/NZ/flat/32.png",
    length: 9,
  },
  {
    code: "PH",
    dialCode: "+63",
    flag: "https://flagsapi.com/PH/flat/32.png",
    length: 10,
  },
  {
    code: "PK",
    dialCode: "+92",
    flag: "https://flagsapi.com/PK/flat/32.png",
    length: 10,
  },
  {
    code: "RU",
    dialCode: "+7",
    flag: "https://flagsapi.com/RU/flat/32.png",
    length: 10,
  },
  {
    code: "SA",
    dialCode: "+966",
    flag: "https://flagsapi.com/SA/flat/32.png",
    length: 9,
  },
  {
    code: "SE",
    dialCode: "+46",
    flag: "https://flagsapi.com/SE/flat/32.png",
    length: 9,
  },
  {
    code: "SG",
    dialCode: "+65",
    flag: "https://flagsapi.com/SG/flat/32.png",
    length: 8,
  },
  {
    code: "US",
    dialCode: "+1",
    flag: "https://flagsapi.com/US/flat/32.png",
    length: 10,
  },
  {
    code: "ZA",
    dialCode: "+27",
    flag: "https://flagsapi.com/ZA/flat/32.png",
    length: 9,
  },
  {
    code: "ZW",
    dialCode: "+263",
    flag: "https://flagsapi.com/ZW/flat/32.png",
    length: 9,
  },
  {
    code: "MO",
    dialCode: "+853",
    flag: "https://flagsapi.com/MO/flat/32.png",
    length: 8,
  },
  {
    code: "MK",
    dialCode: "+389",
    flag: "https://flagsapi.com/MK/flat/32.png",
    length: 8,
  },
  {
    code: "MG",
    dialCode: "+261",
    flag: "https://flagsapi.com/MG/flat/32.png",
    length: 9,
  },
  {
    code: "MW",
    dialCode: "+265",
    flag: "https://flagsapi.com/MW/flat/32.png",
    length: 7,
  },
  {
    code: "MY",
    dialCode: "+60",
    flag: "https://flagsapi.com/MY/flat/32.png",
    length: 10,
  },
  {
    code: "MV",
    dialCode: "+960",
    flag: "https://flagsapi.com/MV/flat/32.png",
    length: 7,
  },
  {
    code: "ML",
    dialCode: "+223",
    flag: "https://flagsapi.com/ML/flat/32.png",
    length: 8,
  },
  {
    code: "MT",
    dialCode: "+356",
    flag: "https://flagsapi.com/MT/flat/32.png",
    length: 8,
  },
  {
    code: "MH",
    dialCode: "+692",
    flag: "https://flagsapi.com/MH/flat/32.png",
    length: 7,
  },
  {
    code: "MR",
    dialCode: "+222",
    flag: "https://flagsapi.com/MR/flat/32.png",
    length: 9,
  },
  {
    code: "MU",
    dialCode: "+230",
    flag: "https://flagsapi.com/MU/flat/32.png",
    length: 7,
  },
  {
    code: "FM",
    dialCode: "+691",
    flag: "https://flagsapi.com/FM/flat/32.png",
    length: 7,
  },
  {
    code: "MD",
    dialCode: "+373",
    flag: "https://flagsapi.com/MD/flat/32.png",
    length: 8,
  },
  {
    code: "MC",
    dialCode: "+377",
    flag: "https://flagsapi.com/MC/flat/32.png",
    length: 8,
  },
  {
    code: "MN",
    dialCode: "+976",
    flag: "https://flagsapi.com/MN/flat/32.png",
    length: 8,
  },
  {
    code: "ME",
    dialCode: "+382",
    flag: "https://flagsapi.com/ME/flat/32.png",
    length: 8,
  },
  {
    code: "MA",
    dialCode: "+212",
    flag: "https://flagsapi.com/MA/flat/32.png",
    length: 9,
  },
  {
    code: "MZ",
    dialCode: "+258",
    flag: "https://flagsapi.com/MZ/flat/32.png",
    length: 9,
  },
  {
    code: "MM",
    dialCode: "+95",
    flag: "https://flagsapi.com/MM/flat/32.png",
    length: 9,
  },
  {
    code: "NA",
    dialCode: "+264",
    flag: "https://flagsapi.com/NA/flat/32.png",
    length: 9,
  },
  {
    code: "NR",
    dialCode: "+674",
    flag: "https://flagsapi.com/NR/flat/32.png",
    length: 7,
  },
  {
    code: "NP",
    dialCode: "+977",
    flag: "https://flagsapi.com/NP/flat/32.png",
    length: 10,
  },
  {
    code: "NI",
    dialCode: "+505",
    flag: "https://flagsapi.com/NI/flat/32.png",
    length: 8,
  },
  {
    code: "NE",
    dialCode: "+227",
    flag: "https://flagsapi.com/NE/flat/32.png",
    length: 8,
  },
  {
    code: "NO",
    dialCode: "+47",
    flag: "https://flagsapi.com/NO/flat/32.png",
    length: 8,
  },
  {
    code: "OM",
    dialCode: "+968",
    flag: "https://flagsapi.com/OM/flat/32.png",
    length: 8,
  },
  {
    code: "PA",
    dialCode: "+507",
    flag: "https://flagsapi.com/PA/flat/32.png",
    length: 7,
  },
  {
    code: "PG",
    dialCode: "+675",
    flag: "https://flagsapi.com/PG/flat/32.png",
    length: 7,
  },
  {
    code: "PY",
    dialCode: "+595",
    flag: "https://flagsapi.com/PY/flat/32.png",
    length: 9,
  },
  {
    code: "PE",
    dialCode: "+51",
    flag: "https://flagsapi.com/PE/flat/32.png",
    length: 9,
  },
  {
    code: "PL",
    dialCode: "+48",
    flag: "https://flagsapi.com/PL/flat/32.png",
    length: 9,
  },
  {
    code: "PT",
    dialCode: "+351",
    flag: "https://flagsapi.com/PT/flat/32.png",
    length: 9,
  },
  {
    code: "QA",
    dialCode: "+974",
    flag: "https://flagsapi.com/QA/flat/32.png",
    length: 8,
  },
  {
    code: "RO",
    dialCode: "+40",
    flag: "https://flagsapi.com/RO/flat/32.png",
    length: 10,
  },
  {
    code: "RW",
    dialCode: "+250",
    flag: "https://flagsapi.com/RW/flat/32.png",
    length: 9,
  },
  {
    code: "WS",
    dialCode: "+685",
    flag: "https://flagsapi.com/WS/flat/32.png",
    length: 7,
  },
  {
    code: "SM",
    dialCode: "+378",
    flag: "https://flagsapi.com/SM/flat/32.png",
    length: 9,
  },
  {
    code: "ST",
    dialCode: "+239",
    flag: "https://flagsapi.com/ST/flat/32.png",
    length: 7,
  },
  {
    code: "SN",
    dialCode: "+221",
    flag: "https://flagsapi.com/SN/flat/32.png",
    length: 9,
  },
  {
    code: "RS",
    dialCode: "+381",
    flag: "https://flagsapi.com/RS/flat/32.png",
    length: 9,
  },
  {
    code: "SC",
    dialCode: "+248",
    flag: "https://flagsapi.com/SC/flat/32.png",
    length: 7,
  },
  {
    code: "SL",
    dialCode: "+232",
    flag: "https://flagsapi.com/SL/flat/32.png",
    length: 8,
  },
  {
    code: "SK",
    dialCode: "+421",
    flag: "https://flagsapi.com/SK/flat/32.png",
    length: 9,
  },
  {
    code: "SI",
    dialCode: "+386",
    flag: "https://flagsapi.com/SI/flat/32.png",
    length: 9,
  },
  {
    code: "SB",
    dialCode: "+677",
    flag: "https://flagsapi.com/SB/flat/32.png",
    length: 7,
  },
  {
    code: "SO",
    dialCode: "+252",
    flag: "https://flagsapi.com/SO/flat/32.png",
    length: 8,
  },
  {
    code: "SS",
    dialCode: "+211",
    flag: "https://flagsapi.com/SS/flat/32.png",
    length: 9,
  },
  {
    code: "LK",
    dialCode: "+94",
    flag: "https://flagsapi.com/LK/flat/32.png",
    length: 9,
  },
  {
    code: "SD",
    dialCode: "+249",
    flag: "https://flagsapi.com/SD/flat/32.png",
    length: 9,
  },
  {
    code: "SR",
    dialCode: "+597",
    flag: "https://flagsapi.com/SR/flat/32.png",
    length: 7,
  },
  {
    code: "SZ",
    dialCode: "+268",
    flag: "https://flagsapi.com/SZ/flat/32.png",
    length: 8,
  },
  {
    code: "CH",
    dialCode: "+41",
    flag: "https://flagsapi.com/CH/flat/32.png",
    length: 9,
  },
  {
    code: "SY",
    dialCode: "+963",
    flag: "https://flagsapi.com/SY/flat/32.png",
    length: 9,
  },
  {
    code: "TW",
    dialCode: "+886",
    flag: "https://flagsapi.com/TW/flat/32.png",
    length: 9,
  },
  {
    code: "TJ",
    dialCode: "+992",
    flag: "https://flagsapi.com/TJ/flat/32.png",
    length: 9,
  },
  {
    code: "TZ",
    dialCode: "+255",
    flag: "https://flagsapi.com/TZ/flat/32.png",
    length: 9,
  },
  {
    code: "TH",
    dialCode: "+66",
    flag: "https://flagsapi.com/TH/flat/32.png",
    length: 9,
  },
  {
    code: "TG",
    dialCode: "+228",
    flag: "https://flagsapi.com/TG/flat/32.png",
    length: 8,
  },
  {
    code: "TO",
    dialCode: "+676",
    flag: "https://flagsapi.com/TO/flat/32.png",
    length: 7,
  },
  {
    code: "TT",
    dialCode: "+1-868",
    flag: "https://flagsapi.com/TT/flat/32.png",
    length: 7,
  },
  {
    code: "TN",
    dialCode: "+216",
    flag: "https://flagsapi.com/TN/flat/32.png",
    length: 8,
  },
  {
    code: "TR",
    dialCode: "+90",
    flag: "https://flagsapi.com/TR/flat/32.png",
    length: 10,
  },
  {
    code: "TM",
    dialCode: "+993",
    flag: "https://flagsapi.com/TM/flat/32.png",
    length: 8,
  },
  {
    code: "TC",
    dialCode: "+1-649",
    flag: "https://flagsapi.com/TC/flat/32.png",
    length: 7,
  },
  {
    code: "TV",
    dialCode: "+688",
    flag: "https://flagsapi.com/TV/flat/32.png",
    length: 7,
  },
  {
    code: "UG",
    dialCode: "+256",
    flag: "https://flagsapi.com/UG/flat/32.png",
    length: 9,
  },
  {
    code: "UA",
    dialCode: "+380",
    flag: "https://flagsapi.com/UA/flat/32.png",
    length: 9,
  },
  {
    code: "AE",
    dialCode: "+971",
    flag: "https://flagsapi.com/AE/flat/32.png",
    length: 9,
  },
  {
    code: "UY",
    dialCode: "+598",
    flag: "https://flagsapi.com/UY/flat/32.png",
    length: 9,
  },
  {
    code: "UZ",
    dialCode: "+998",
    flag: "https://flagsapi.com/UZ/flat/32.png",
    length: 9,
  },
  {
    code: "VU",
    dialCode: "+678",
    flag: "https://flagsapi.com/VU/flat/32.png",
    length: 7,
  },
  {
    code: "VA",
    dialCode: "+379",
    flag: "https://flagsapi.com/VA/flat/32.png",
    length: 8,
  },
  {
    code: "VE",
    dialCode: "+58",
    flag: "https://flagsapi.com/VE/flat/32.png",
    length: 10,
  },
  {
    code: "VN",
    dialCode: "+84",
    flag: "https://flagsapi.com/VN/flat/32.png",
    length: 9,
  },
  {
    code: "WF",
    dialCode: "+681",
    flag: "https://flagsapi.com/WF/flat/32.png",
    length: 6,
  },
  {
    code: "YE",
    dialCode: "+967",
    flag: "https://flagsapi.com/YE/flat/32.png",
    length: 9,
  },
  {
    code: "ZM",
    dialCode: "+260",
    flag: "https://flagsapi.com/ZM/flat/32.png",
    length: 9,
  },
];
